import { Static, Type } from '@sinclair/typebox';

export const EmailNotificationMetadataSchema = Type.Object(
  {
    topic: Type.String({ minLength: 1 }),
    dedupe_key: Type.String({ minLength: 1 }),
    reference_type: Type.Optional(Type.String({ minLength: 1 })),
    reference_id: Type.Optional(Type.String({ minLength: 1 })),
    metadata: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
    recipient: Type.String({ minLength: 1 }),
    template: Type.String({ minLength: 1 }),
    subject: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false }
);

export type EmailNotificationMetadata = Static<
  typeof EmailNotificationMetadataSchema
>;

export const CUSTOMER_LIFECYCLE_RESTOCK_EMAIL_KEY =
  'customer-lifecycle-restock' as const;

export const CustomerLifecycleRestockEmailPayloadSchema = Type.Object(
  {
    email: Type.String({ minLength: 1 }),
    template: Type.Literal(CUSTOMER_LIFECYCLE_RESTOCK_EMAIL_KEY),
    requirement: Type.Literal(CUSTOMER_LIFECYCLE_RESTOCK_EMAIL_KEY),
    outlet: Type.String({ minLength: 1, pattern: '\\S' }),
  },
  { additionalProperties: true }
);

export type CustomerLifecycleRestockEmailPayload = Static<
  typeof CustomerLifecycleRestockEmailPayloadSchema
>;

export const CUSTOMER_LIFECYCLE_WELCOME_EMAIL_KEY =
  'customer-lifecycle-welcome' as const;

export const CustomerLifecycleWelcomeEmailPayloadSchema = Type.Object(
  {
    email: Type.String({ minLength: 1 }),
    template: Type.Literal(CUSTOMER_LIFECYCLE_WELCOME_EMAIL_KEY),
    requirement: Type.Literal(CUSTOMER_LIFECYCLE_WELCOME_EMAIL_KEY),
    outlet: Type.String({ minLength: 1, pattern: '\\S' }),
    voucher_count: Type.Integer({ minimum: 0 }),
    email_notification: Type.Optional(EmailNotificationMetadataSchema),
  },
  { additionalProperties: false }
);

export type CustomerLifecycleWelcomeEmailPayload = Static<
  typeof CustomerLifecycleWelcomeEmailPayloadSchema
>;

export const CUSTOMER_LIFECYCLE_CART_EMAIL_KEY =
  'customer-lifecycle-cart' as const;

export const CustomerLifecycleCartEmailPayloadSchema = Type.Object(
  {
    email: Type.String({ minLength: 1 }),
    template: Type.Literal(CUSTOMER_LIFECYCLE_CART_EMAIL_KEY),
    requirement: Type.Literal(CUSTOMER_LIFECYCLE_CART_EMAIL_KEY),
    outlet: Type.String({ minLength: 1, pattern: '\\S' }),
    email_notification: Type.Optional(EmailNotificationMetadataSchema),
  },
  { additionalProperties: false }
);

export type CustomerLifecycleCartEmailPayload = Static<
  typeof CustomerLifecycleCartEmailPayloadSchema
>;

export const UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY =
  'universal-registration-otp' as const;

export const UniversalRegistrationOtpEmailPayloadSchema = Type.Object(
  {
    email: Type.String({ minLength: 1 }),
    template: Type.Literal(UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY),
    requirement: Type.Literal(UNIVERSAL_REGISTRATION_OTP_EMAIL_KEY),
    otp: Type.String({ pattern: '^\\d{6}$' }),
    expires_in_minutes: Type.Integer({ minimum: 1 }),
    otp_expires_at: Type.Integer({ minimum: 1 }),
  },
  { additionalProperties: true }
);

export type UniversalRegistrationOtpEmailPayload = Static<
  typeof UniversalRegistrationOtpEmailPayloadSchema
>;
